/**
 *
 * TimeSpanPlannerStep
 *
 */
import {Component} from "react";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import styled from "styled-components";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import StepArrows from "components/MultiStep/StepArrows";
import {CenterHorizontal, Content,} from "basicComponents/FormComponents/FormComponents";
import ActionButton from "basicComponents/ActionButton/ActionButton";
import {
  checkAvailability,
  getScannerAvailability,
  getTimeslotDrivers,
  getTimeSlotsAction,
  getTimeSlotsFailedAction,
  getTimeSlotsSuccessAction,
  saveActivityAction
} from "containers/TimeSlotPlanner/actions";
import {
  makeSelectScanners,
  makeSelectScannersLoading,
  makeSelectTimeslotDrivers,
  makeSelectTimeslotDriversLoading,
  makeSelectTimeSlotsLoading,
  makeSelectTimeWindows,
} from "containers/TimeSlotPlanner/selectors";
import TreatmentDatePicker from "components/TreatmentDatePicker/TreatmentDatePicker";
import GlobalMessages from "messages/messages";
import {makeSelectPlannedTimeSlots, makeSelectTreatments,} from "containers/App/selectors";
import {getPlannedTimeSlotsAction, getTreatmentsAction,} from "containers/App/actions";
import history from "utils/history";
import moment from "moment";
import messages from "./messages";
import DateTimePicker from "../../../../components/DateTimePicker/DateTimePicker";
import {isOutOfMax} from "utils/Date";
import {createSortedAvailableTimeWindows} from "utils/SortedAvailableTimeWindow";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import {getBearer, hasRole, ROLES} from "../../../../utils/userStorage";
import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import LoadingAnimation from "../../../../basicComponents/LoadingAnimation/LoadingAnimation";
import DayChart from "components/DayChart/DayChart";
import Calendar from "components/DayChart/Calendar";
import { getPractice } from "utils/practiceStorage";

export class TimeSlotPlannerStep extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    getTimeSlots: PropTypes.func.isRequired,
    getTimeSlotsFailedAction: PropTypes.func.isRequired,
    getTimeSlotsSuccessAction: PropTypes.func.isRequired,
    timeWindows: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    saveActivity: PropTypes.func.isRequired,
    timeSlotId: PropTypes.number,
    getPlannedTimeSlots: PropTypes.func.isRequired,
    plannedTimeSlots: PropTypes.array.isRequired,
    checkAvailability: PropTypes.func.isRequired,
    getTreatments: PropTypes.func.isRequired,
    treatments: PropTypes.array.isRequired,
    // drivers
    drivers: PropTypes.array,
    onGetDrivers: PropTypes.func,
    onGetScannerAvailability: PropTypes.func,
    driversLoading: PropTypes.bool,
    scanners: PropTypes.object,
    scannersLoading: PropTypes.bool
  };

  static defaultProps = {
    timeSlotId: -1,
    scanners: {
      total: 0,
      available: 0
    }
  };

  cancelTask = false;

  componentDidMount() {
    this.cancelTask = false;
    this.props.getTreatments();
    this.props.getPlannedTimeSlots();

    if (hasRole(ROLES.Admin)) {
      this.props.onGetDrivers();
      this.props.onGetScannerAvailability(this.state.date);
    }
  }

  componentWillUnmount() {
    this.cancelTask = true;
  }

  async getData(date, duration, kptOverride, withScanner) {
    try {
      this.props.checkAvailability(
        date || this.state.date,
        duration || this.state.duration,
        kptOverride || this.state.kptOverride,
        withScanner || this.state.withScanner,
        this.handleData,
      );
      this.setState({ available: {} });
    } catch (e) {
      this.setState({
        available: {},
      });
    }
  }

  state = {
    duration: 3,
    date: history.location.date || new Date(),
    checkedDate: new Date(),
    timeWindow: null,
    buttonClickable: true,
    planAdvanceMessage: false,
    available: {},
    // list to concatenate after receiving new data.
    currentAvailableList: {},
    daysAhead: 2,
    count: 0,
    chosenDate: null,
    kptOverride: null,
    withScanner: true,
    times:[]
  };

  handleData = data => {
    if (this.cancelTask) {
      return;
    }
    // this checks if it's not in the timeSlot
    const {
      date,
      currentAvailableList,
      count,
      daysAhead,
      chosenDate,
    } = this.state;
    let available = createSortedAvailableTimeWindows(
      data.additional_data.available_timewindows,
    );
    this.setState(() => {
      // this is to concatenate Array of objects
      available = { ...currentAvailableList, ...available };

      return {
        available,
        currentAvailableList: available,
        unavailable: false,
      };
    });

    // this request additional days ahead to be shown. daysAhead will be a variable.
    if (this.state.count < daysAhead) {
      // Skip weekend and go to next day.
      do {
        chosenDate.setDate(chosenDate.getDate() + 1);
      } while (chosenDate.getDay() === 6 || chosenDate.getDay() === 0);

      this.getData(chosenDate);
      this.setState({ available, count: count + 1 });
    }
  };

  handleTimeWindowSelected = timeWindow => {
    this.setState({
      timeWindow,
    });
  };

  handleDurationChanged = duration => {
    this.setState({
      duration,
      buttonClickable: true,
    });
  };

  handleDateChanged = date => {
    let datestring = moment(date).format('YYYY-MM-DD')
    var practice = getPractice()
    fetch(`${__URLS__["api"]}practices/${practice.id}/plannedDay?date=${datestring}`,{
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getBearer()}`,
      },
    }).then(res => res.json()).then((data) => {
      console.log(data.plannedTreatments)
      this.setState({times:data.plannedTreatments})
    })

    if (hasRole(ROLES.Admin)) {
      this.props.onGetScannerAvailability(date);
    }

    const value = moment(date);
    const maxDateFromSelected = !isOutOfMax(value);
    if (maxDateFromSelected) {
      this.setState({
        date,
        buttonClickable: true,
        planAdvanceMessage: false,
      });
    } else {
      this.setState({
        planAdvanceMessage: true,
      });
    }
  };

  handleNextClicked = () => {
    if (!this.state.timeWindow) {
      return;
    }

    this.props.saveActivity({
      duration: this.state.duration * 60,
      time_slots: [this.state.timeWindow],
      tag_names: ["blok"],
      withScanner: this.state.withScanner,
    });
    this.props.onNext();
  };

  handleCheckClicked = () => {
    const { date, duration } = this.state;

    this.setState(prevState => ({
      chosenDate: date,
      count: 0,
      available: {},
      currentAvailableList: {},
      buttonClickable: false,
      timeWindow: null,
      checkedDate: moment(prevState.date),
    }));
    this.getData(date, duration, this.state.kptOverride, this.state.withScanner);
  };

  handleKptOverrideSelect = selected => {
    this.setState({
      kptOverride: selected,
      buttonClickable: true,
    });
  };

  hasSelectedTime() {
    for (const key in this.state.available) {
      if (!this.state.available.hasOwnProperty(key)) {
        continue;
      }
      const date = moment(key, "YYYY-MM-DD");

      if (date.isSame(this.state.checkedDate, "d")) {
        return true;
      }
    }
    return false;
  }

  renderDatePicker() {
    let result = null;

    if (Object.keys(this.state.available).length > 0) {
      result = (
        <>
          {!this.hasSelectedTime() && (
            <DifferentDateWarning>
              <FormattedMessage {...messages.differentDate} />
            </DifferentDateWarning>
          )}
          <TreatmentDatePicker
            locale="en"
            onTimeWindowSelected={this.handleTimeWindowSelected}
            timeWindows={this.state.available}
          />
          <PlanButtonContainer>
            <ActionButton
              id="planButton"
              disabled={!this.state.timeWindow}
              onClick={this.handleNextClicked}
            >
              <FormattedMessage {...GlobalMessages.planDayPart} />
            </ActionButton>
          </PlanButtonContainer>
        </>
      );
    } else {
      result = (
        <CenterHorizontal fullWidth>
          <FormattedMessage {...messages.noAvailableTimeSlots} />
        </CenterHorizontal>
      );
    }

    return (
      <>
        <Divider />
        {result}
      </>
    );
  }

  render() {
    const { planAdvanceMessage } = this.state;

    return (
      <StepArrows fullWidth leftDisabled rightDisabled>
        <Content id="TimeSlotPlannerStep" fullWidth>
          <TimePickerWrapper>
            <TimePickerContainer>
              {hasRole(ROLES.Admin) && (
              <ScannerSelectorContainer style={{background:'white', padding:'10px',border:'1px solid black', borderRadius:'5px'}}>
                <ToggleButton
                  disabled={false}
                  onChange={({ value }) => {
                    this.setState({ withScanner: value,       buttonClickable: true });
                  }}
                  label={
                    <FormattedMessage {...messages.optionalScanner} />
                  }
                  options={[
                    {
                      value: true,
                      id: 1,
                      label: (
                        <FormattedMessage {...GlobalMessages.yesButtonText} />
                      ),
                    },
                    {
                      value: false,
                      id: 2,
                      label: (
                        <FormattedMessage {...GlobalMessages.noButtonText} />
                      ),
                    },
                  ]}
                  value={this.state.withScanner}
                />
                <FormControl style={{marginLeft:15}} disabled={this.props.driversLoading}>
                  <InputLabel shrink>
                    <FormattedMessage {...messages.kptOverrideTitle} />
                  </InputLabel>
                  <Select
                    displayEmpty
                    fullWidth
                    value={this.state.kptOverride}
                    onChange={val => {
                      this.handleKptOverrideSelect(val.target.value);
                    }}
                  >
                    <MenuItem key={1} value={null}>
                      <FormattedMessage {...messages.kptOverrideEmpty} />
                    </MenuItem>
                    {(this.props.drivers || []).map(driver => (
                      <MenuItem
                        key={`driver_${driver.id}`}
                        value={driver.id}
                      >
                        {driver.first_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ScannerSelectorContainer>)}

              <div style={{display:'flex',justifyContent:'center',gap:'30px'}}>
                <div>
                  <div>
                    <div><h2>{moment(this.state.date).format('dddd')}</h2></div>
                    <div><h3>{this.state.date.toLocaleDateString()}</h3></div>
                  </div>
                  <div style={{width:'20rem',height:'400px', background:'white',border:'1px solid black', borderRadius:'5px',position:'relative'}}>
                    {(() => {
                      return new Array(9).fill(0).map((v,i) => {
                        return <div style={{height:((400 - 1) / 9) + 'px',borderBottom:'1px solid grey'}}>{i + 9}:00</div>
                      })
                    })()}
                    {this.state?.times?.map?.((plannedtreatment) => {
                      var from = moment(plannedtreatment.planned_date_time_from)
                      var to = moment(plannedtreatment.planned_date_time_to)
                      var daystart = 8
                      var dayend = 17
                      var starttime = from.hour() + from.minutes() / 60
                      var endtime = to.hour() + to.minutes() / 60
                      let duration = endtime - starttime
                      
                      return <div style={{left:'50px', top:`${remap(starttime,daystart,dayend,0,400)}px`,width:'calc(100% - 70px)',height:`${remap(duration,0,9,0,400)}px`,borderRadius:'3px',border:'1px solid black', background:'white',position:'absolute'}}>
                        {plannedtreatment.patientName} <span style={{float:'right'}}>{from.format('HH:mm')}-{to.format('HH:mm')}</span>
                        {/* {Math.floor(duration * 60)}min */}
                        
                      </div>
                    })}
                  </div>
                </div>
                <DateTimePicker
                  alwaysOpen
                  value={this.state.date}
                  onChange={this.handleDateChanged}
                  onHoursChange={this.handleDurationChanged}
                  hours={this.state.duration}
                  minHours={hasRole(ROLES.User)? 2 : 1}
                  maxHours={8}
                  noHoursLoop
                  treatments={this.props.treatments}
                  highlightedValue={this.props.plannedTimeSlots}
                  scannersAvailable={this.props?.scanners?.available || 0}
                  scannersTotal={this.props?.scanners?.total || 0}
                />
              </div>
              <ButtonWrapper>

                {!planAdvanceMessage ? (
                  <ActionButton
                    id="checkAvailability"
                    disabled={!this.state.buttonClickable}
                    onClick={this.handleCheckClicked}
                  >
                    <FormattedMessage {...GlobalMessages.checkAvailability} />
                  </ActionButton>
                ) : (
                  <FormattedMessage {...GlobalMessages.planAdvance} />
                )}
              </ButtonWrapper>
            </TimePickerContainer>
          </TimePickerWrapper>
          {this.props.loading && <LoadingAnimation contained />}
          {this.renderDatePicker()}
        </Content>
      </StepArrows>
    );
  }
}

const DifferentDateWarning = styled.div`
  color: ${({ theme }) => theme.palette.error.main};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const PlanButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const TimePickerContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TimePickerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ScannerSelectorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);
  padding-bottom: 5px;
  margin: 15px;

  & > * {
    width: 250px;
  }
`;

const Divider = styled.div`
  margin-top: ${({ theme }) => theme.margin}rem;
  margin-bottom: ${({ theme }) => theme.margin}rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
`;

const ButtonWrapper = styled.div`
  margin-top: ${({ theme }) => theme.margin}rem;
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;

function mapDispatchToProps(dispatch) {
  return {
    getTimeSlots: () => dispatch(getTimeSlotsAction()),
    getTimeSlotsSuccessAction: timeWindows =>
      dispatch(getTimeSlotsSuccessAction(timeWindows)),
    getTimeSlotsFailedAction: () => dispatch(getTimeSlotsFailedAction()),
    saveActivity: activity => dispatch(saveActivityAction(activity)),
    getPlannedTimeSlots: () => dispatch(getPlannedTimeSlotsAction()),
    checkAvailability: (date, duration, kptOverride, withScanner, callback) =>
      dispatch(checkAvailability(date, duration, kptOverride, withScanner, callback)),
    getTreatments: () => dispatch(getTreatmentsAction()),
    onGetDrivers: () => dispatch(getTimeslotDrivers()),
    onGetScannerAvailability: (date) => dispatch(getScannerAvailability(date))
  };
}

const mapStateToProps = createStructuredSelector({
  treatments: makeSelectTreatments(),
  timeWindows: makeSelectTimeWindows(),
  loading: makeSelectTimeSlotsLoading(),
  plannedTimeSlots: makeSelectPlannedTimeSlots(),
  drivers: makeSelectTimeslotDrivers(),
  driversLoading: makeSelectTimeslotDriversLoading(),
  scanners: makeSelectScanners(),
  scannersLoading: makeSelectScannersLoading(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);


function lerp(a, b, t) {
  return a + (b - a) * t;
}

function inverseLerp(a, b, v) {
  return (v - a) / (b - a);
}

function remap(v, inMin, inMax, outMin, outMax) {
  const t = inverseLerp(inMin, inMax, v);
  return lerp(outMin, outMax, t);
}


export default compose(withConnect)(TimeSlotPlannerStep);
